export default {
	// api请求地址
	baseUrl: "https://www.snwmall.com",
	// 图片域名
	imgDomain: "https://www.snwmall.com",
	// 腾讯地图key
	mpKey: 'IM4BZ-RCTKV-P5XPD-U7TQL-5RI3F-CNB5T',
	// 客服
	webSocket: 'wss://www.snwmall.com/wss',
	// api安全
	apiSecurity: "{{$apiSecurity}}",
	//本地端主动给服务器ping的时间, 0 则不开启 , 单位秒
	pingInterval: 1500,
	// 公钥
	publicKey: `{{$publicKey}}`,
}